
import { Component, Vue, Prop, Watch, Emit, Mixins, Ref } from 'vue-property-decorator'
import Title from '../Title/index.vue'
import CalendarCard from '../CalendarCard/index.vue'
import LiveClasshourCard from '../LiveClasshourCard/index.vue'
import CalendarSwiper from '../CalendarSwiper/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { ICalendarData } from '@xt/client/types/my-go-course'
import { $service } from '@xt/client/experimental/request/service'
import { Observer } from 'mobx-vue'
import type { CalendarTimeData } from '@xt/client/entities/my-v2/types'
import { formatYearMonthDay } from '@xt/client/utils/my'
import moment from 'moment'

@Observer
@Component({
  components: {
    Title,
    LazyImg,
    CalendarCard,
    LiveClasshourCard,
    CalendarSwiper
  }
})
export default class MyCalendar extends Vue {
  activeDate: number = 0
  currentDate: number = 0
  classhourInfo: Array<ICalendarData> = []
  calendarImg: string = ''

  currentSwiper: number = 1

  get MyClassroomStore() {
    return this.$store.$myV2.Classroom
  }

  formatCalendarCardData(item: CalendarTimeData) {
    return {
      ...item,
      isActiveDay: moment(this.activeDate).isSame(item.timestamp, 'day'),
      isCurrentDay: moment(this.currentDate).isSame(item.timestamp, 'day'),
      isExistClasshour:
        this.MyClassroomStore.allClasshourList.findIndex(v => {
          // 如果是头部临时课 ｜ 尾部临时课
          if (v.classhourType !== 1) {
            return moment(v.startTime).isSame(item.timestamp, 'day') && v.publishStatus === 1
          }
          return moment(v.startTime).isSame(item.timestamp, 'day')
        }) > -1
    }
  }

  handleChangeActive(date: Omit<CalendarTimeData, 'w'>) {
    this.updateActiveDate(date.timestamp)
    this.updateClasshourInfo(date)
  }

  updateClasshourInfo(date: Omit<CalendarTimeData, 'w'>) {
    // 年 月 日相等 && 如果是头部临时课或者尾部临时课，就需要判断发布状态
    this.classhourInfo = this.MyClassroomStore.allClasshourList.filter(
      item => moment(item.startTime).isSame(date.timestamp, 'day') && (item.classhourType !== 1 ? item.publishStatus === 1 : true)
    )
  }

  // 点击更新日期
  updateActiveDate(time: number) {
    this.activeDate = time
  }

  // 获取当前时间
  getCurrentTime() {
    const now = this.$ajax.serviceDate().utcOffset(+8).valueOf()
    const { y, m, d } = formatYearMonthDay(now)

    return { y, m, d, timestamp: now }
  }

  getDayOfWeekUrl(index: number) {
    return `${this.$store.$global.static}/images/my-new/pc/my-classroom-calender-ico${index}.svg`
  }

  // 加载日历背景图
  async loadCalendarBgImg(month: number) {
    const [err, data] = await $service<{
      cover: string[]
    }>({
      method: 'GET',
      url: '/mocks/calendar-pc.json',
      baseURL: this.$store.$global.static
    })

    if (err) throw err

    this.calendarImg = data?.cover.length === 12 ? data.cover[month] : ''
  }

  async created(): Promise<void> {
    await this.MyClassroomStore.initCalendarData()

    // 初始化当前时间
    const date = this.getCurrentTime()
    this.currentDate = date.timestamp

    // 初始化日历图片
    await this.loadCalendarBgImg(date.m - 1)

    // 初始化选中时间，默认选中今天；初始化当前选中日期的课时信息
    this.handleChangeActive(date)
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
